import moment from 'moment';
import { teamActionTypes } from './Team.actionTypes';
import { IS_DEMO_MODE } from '@/utils/demoMode';

const loadTeam = localStorage.getItem('teamData');
const loadAllTeam = localStorage.getItem('Team');
const members = localStorage.getItem('members');
const topUserProjects = localStorage.getItem('topProjects');

// Demo mode: no real Firestore team docs exist for the demo profile, so
// nothing ever populates `teams`/`activeTeam`/`selectedTeamID` for real —
// seed them here so the header's Department pill dropdown (and every other
// Redux consumer of state.team) has data from the very first render. Ids
// match EmployeeList.demoData.js's DEMO_TEAM_OPTIONS for consistency across
// the demo.
const DEMO_TEAMS_DATA = [
  { activeTeamid: 'demo-team-engineering', Team: 'Engineering' },
  { activeTeamid: 'demo-team-sales', Team: 'Sales' },
  { activeTeamid: 'demo-team-support', Team: 'Customer Support' },
];
const DEMO_ACTIVE_TEAM = {
  Team: 'Engineering',
  activeTeamid: 'demo-team-engineering',
  activeTeamId: 'demo-team-engineering',
};

const initialState = {
  loading: false,
  loadingProject: true,
  teamLoading: false,
  selectedTeamID: IS_DEMO_MODE ? DEMO_ACTIVE_TEAM.activeTeamid : null,
  activeUserID: null,
  selectedDate: moment().format('DD:M:YYYY'),
  week: moment().isoWeek().toString(),
  timelogDayRange: 0,
  start: '',
  end: '',
  activeTeam: IS_DEMO_MODE ? DEMO_ACTIVE_TEAM : {},
  teamMembers: [],
  teams: IS_DEMO_MODE
    ? { success: true, data: DEMO_TEAMS_DATA }
    : loadAllTeam?.length === 0
      ? []
      : JSON.parse(loadAllTeam),
  teamLogs: [],
  days: [],
  projects: [],
  selectedProject: {},
  tasks: [],
  all: true,
  teamData: {},
  weekData: {},
  topData: {},
  membersData: {},
  threshold: '',
  attendanceData: [],
  active: IS_DEMO_MODE
    ? DEMO_ACTIVE_TEAM
    : loadTeam?.length === 0
      ? []
      : JSON.parse(loadTeam),
  teamTimeData: {},
  topProjects: [],
  selectedProject: '',
  selectTeams: [],
  sevenDayData: {},
  thirtyDayData: {},
  untrackedUsers: {},
  days: 0,
  companiesWithSubscription: [],
  subscriptionLoading: false,
};

export default function teamReducer(state = initialState, action) {
  switch (action.type) {
    case teamActionTypes.SET_STATE:
      return { ...state, ...action.payload };
    // NEW: Handle subscription teamActionTypes
    case teamActionTypes.SET_COMPANIES_WITH_SUBSCRIPTION:
      return {
        ...state,
        companiesWithSubscription: action.payload,
        subscriptionLoading: false,
      };
    case teamActionTypes.GET_COMPANIES_WITH_SUBSCRIPTION:
      return {
        ...state,
        subscriptionLoading: true,
      };
    case teamActionTypes.PATCH_TEAM_TIMEZONE: {
      const { teamId, timeZone } = action.payload;
      const updatedData = (state.teams?.data ?? []).map((t) =>
        t.activeTeamid === teamId ? { ...t, timeZone } : t
      );
      const updatedTeams = { ...state.teams, data: updatedData };
      localStorage.setItem('Team', JSON.stringify(updatedTeams));
      return { ...state, teams: updatedTeams };
    }
    default:
      return state;
  }
}
